import api from "../../../services/api";

export const cvAdminApi = {
  async listSubmissions(params) {
    const res = await api.get("/cv/admin/submissions", { params });
    return res.data;
  },

  async getSubmission(userId) {
    const res = await api.get(`/cv/admin/submissions/${userId}`);
    return res.data;
  },

  async updateSubmission(userId, payload) {
    const res = await api.put(`/cv/admin/submissions/${userId}`, payload);
    return res.data;
  },

  async deleteSubmission(userId) {
    const res = await api.delete(`/cv/admin/submissions/${userId}`);
    return res.data;
  },

  async approve(userId) {
    const res = await api.post(`/cv/admin/submissions/${userId}/approve`, {});
    return res.data;
  },

  async reject(userId, reason) {
    const res = await api.post(`/cv/admin/submissions/${userId}/reject`, { reason });
    return res.data;
  },

  async reopen(userId, days, note) {
    const res = await api.post(`/cv/admin/submissions/${userId}/reopen`, {
      days: Number(days || 7),
      note: note || null,
    });
    return res.data;
  },

  async closeWindow(userId) {
    const res = await api.post(`/cv/admin/submissions/${userId}/close-window`, {});
    return res.data;
  },

  async versions(userId) {
    const res = await api.get(`/cv/generated-versions/${userId}`);
    return res.data;
  },

  async generate(userId, payload) {
    const res = await api.post(`/cv/generate/${userId}`, payload);
    return res.data;
  },

  async overrideProfile(payload) {
    const res = await api.put(`/cv/admin/override-profile`, payload);
    return res.data;
  },

  async adminOverrideProfile(payload) {
    const res = await api.put(`/cv/admin/override-profile`, payload);
    return res.data;
  },

  async overrideCvProfile(payload) {
    const res = await api.put(`/cv/admin/override-profile`, payload);
    return res.data;
  },

  downloadVersion(versionId) {
    return api.get(`/cv/generated-versions/download/${versionId}`, { responseType: "blob" });
  },

  /* ---------------------------
   * ✅ NEW: CV Email Requests
   * --------------------------- */

  /**
   * Backend should accept:
   * POST /cv/admin/send-fill-request
   * payload: { scope, only_pending, only_not_started, open_window, days|until, reopen, note, subject, title, intro, cta_text, cv_url, user_id|employee_codes }
   */
  async sendFillRequest(payload) {
    const res = await api.post(`/cv/admin/send-fill-request`, payload);
    return res.data;
  },

  /**
   * Optional if you implemented it:
   * POST /cv/admin/remind-pending
   */
  async remindPending(payload) {
    const res = await api.post(`/cv/admin/remind-pending`, payload);
    return res.data;
  },
};
